import { request } from '../../helpers/api/request';
import {
    AdditionalSettings,
    GetDocumentsContract,
} from '../../types/Endpoints/documents/DocumentsContracts';

export const updateAdditionalSettings = async (requestData: AdditionalSettings) => {
    const { data } = await request<GetDocumentsContract>({
        url: 'admin/settings',
        method: 'PATCH',
        data: requestData,
    });

    return data;
};
